import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/PrivateOffice.css'
import xm1 from '../assets/images/space.png'
import o1 from '../assets/images/o1.png'
import o2 from '../assets/images/o2.png'
import o3 from '../assets/images/o3.png'
import ep from '../assets/images/ep.png'
import ov1aa from '../assets/images/ov1aa.png'
import ov1bb from '../assets/images/ov1bb.png'
import ov1cc from '../assets/images/ov1cc.png'
import ov1dd from '../assets/images/ov1dd.png'
import ov1ee from '../assets/images/ov1ee.png'
import ov1ff from '../assets/images/ov1ff.png'

import {Helmet}from"react-helmet";

import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'


/* ✅ CTA + WHY icons (NEW) */
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);



const ExectiveOffices = () => {
  const [openIndex, setOpenIndex] = useState(null);

   useEffect(() => {
    AOS.init();
  }, []);

 

  return (
    <div>

          <Helmet>
      
      <title>Pricing Plans for Xceed Office CRM | Affordable Plans & Free Trial</title>
      <meta name="description" content="Compare Xceed Office CRM pricing plans for professionals and teams. Explore features, scalable plans, and start with a free trial today."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>
      {/* 🔶 HERO SECTION */}
      <section className="p_main">
        <div className="p_main_sec">
          <h1>

           Lead From the <span style={{ color: "#EEBD2B" }}>Top</span>

                       <br /> 

<span style={{ color: "#EEBD2B" }}>Floor.</span>


          </h1>

          <p>   Elevate your leadership presence with a fully serviced executive
suite. Premium space, absolute privacy, and white-glove service
for those who expect nothing less.
 </p>

<div style={{display:"flex"}}>
        <button>
                    <a href="https://calendly.com/xceedoffice-info/new-meeting?month=2026-03">Schedule a Private Tour</a>    </button>       <a href="tel:+1 (281) 270-6431">
  <button
    style={{
      background: "#0D0D0D",
      color: "#EEBD2B",
      opacity: 1,
      alignItems: "center",
      display: "flex",
      cursor: "pointer",
    }}
  >
    <span className="cta__btnIcon">
      <IconCall />
    </span>
    <span>&nbsp; Call Now</span>
  </button>
</a>
</div>
    

        </div>
      </section>


  <section class="included-section">
  <div class="included-header">
    <h2>What's Included</h2>
    <p>
     Every executive suite at Xceed is designed to the highest standard, with services
befitting senior leadership.
    </p>
  </div>

  <div class="included-grid">
    <div class="included-card">
      <div class="icon"><img src={ov1aa} alt="" /></div>
      <h3>Prestigious Address</h3>
      <p>Establish your executive presence at a
premier Houston business address that
commands respect.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1bb} alt="" /></div>
     <h3>Absolute Privacy</h3>
      <p>Biometric access, soundproofing, and
secure infrastructure designed for
confidential executive work.</p>
     </div>

    <div class="included-card">
      <div class="icon"><img src={ov1cc} alt="" /></div>
       <h3>Enterprise Technology</h3>
      <p>Dedicated high-speed fiber, secure VPN,
professional AV systems, and on-site IT
support.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1dd} alt="" /></div>
          <h3>Executive Amenities</h3>
      <p>Private lounges, premium refreshments,
and white-glove hospitality for you and
your guests.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1ee} alt="" /></div>
      <h3>Boardroom Access</h3>
      <p>Executive boardrooms with advanced
conferencing technology, ideal for high-
stakes meetings.</p>
    </div>

    <div class="included-card">
      <div class="icon"><img src={ov1ff} alt="" /></div>
      <h3>Turnkey Occupancy</h3>
      <p>Move in immediately to a fully appointed
executive suite — no capital investment
or setup required.</p>
    </div>
  </div>
</section>
<section className="private-office-section">
  <div className="private-office-header">
    <h2>Choose Your Private Office</h2>
    <p>
      From executive suites to fully equipped team rooms — designed for every
      stage of your business.
    </p>
  </div>

  <div className="office-grid">
    {/* Card 1 */}
    <div className="office-card">
      <div className="office-icon"><img src={o1} alt="" /></div>

      <h3>Executive Suite</h3>
      <span>1–2 PEOPLE</span>

      <p className="office-desc">
        A distinguished executive suite designed for senior leadership who
        demand privacy, prestige, and premium service.
      </p>

      <div className="price">
        $2,500 <small>/ month</small>
      </div>

      <ul>
        <li>Premium furnished executive suite</li>
        <li>Lockable door & 24/7 secure access</li>
        <li>Dedicated business phone line</li>
        <li>10 hours executive boardroom/month</li>
        <li>Priority mail & package handling</li>
        <li>Concierge-level hospitality</li>
      </ul>

      <button>Reserve This Suite</button>
    </div>

    {/* Card 2 */}
    <div className="office-card popular">
      <div className="badge">MOST POPULAR</div>

      <div className="office-icon"><img src={o2} alt="" /></div>

      <h3>Prestige Suite</h3>
      <span>2–4 PEOPLE</span>

      <p className="office-desc">
        An expansive corner suite with panoramic views, crafted for executive
        teams and senior partners.
      </p>

      <div className="price">
        $3,800 <small>/ month</small>
      </div>

      <ul>
        <li>Corner suite with panoramic views</li>
        <li>Executive-grade furnishings & finishes</li>
        <li>Private reception area option</li>
        <li>15 hours executive boardroom/month</li>
        <li>Dedicated parking & valet option</li>
        <li>White-glove concierge service</li>
      </ul>

      <button>Reserve This Suite</button>
    </div>

    {/* Card 3 */}
    <div className="office-card">
      <div className="office-icon"><img src={o3} alt="" /></div>

      <h3>Chairman Suite</h3>
      <span>4–6 PEOPLE</span>

      <p className="office-desc">
        The pinnacle of executive workspace. A fully private wing for C-suite
        teams requiring absolute discretion.
      </p>

      <div className="price">
        $5,500 <small>/ month</small>
      </div>

      <ul>
        <li>Private executive wing with entry</li>
        <li>Custom branding & interior options</li>
        <li>Private meeting room within suite</li>
        <li>25 hours boardroom access/month</li>
        <li>Dedicated administrative support</li>
        <li>Private storage & secure document room</li>
      </ul>

      <button>Reserve This Suite</button>
    </div>
  </div>
</section>
   
 <section className="why-choose-section">
  <div className="why-choose-container">

    {/* Left Image */}
    <div className="why-choose-image">
      <img
        src={ep}
        alt="Executive Suite Boardroom"
      />
    </div>

    {/* Right Content */}
    <div className="why-choose-content">
      <h2>Why Leaders Choose Xceed Executive Suites</h2>

      <p>
        Traditional office leases demand capital, time, and long-term
        commitment. Xceed Executive Suites deliver the prestige and privacy
        of a corner office without the burden — so you can focus on leading.
      </p>

      <ul className="benefits-list">
        <li>Zero capital expenditure or buildout costs</li>
        <li>Flexible terms without long-term lease risk</li>
        <li>Impeccable executive image from day one</li>
        <li>Scalable as your leadership team evolves</li>
        <li>Full-service staff dedicated to your success</li>
        <li>Class A address that elevates your brand</li>
      </ul>
    </div>

  </div>
</section>
 
 

      {/* ✅ CTA SECTION (ADDED) */}
      <section  className="cta">
        <div className="cta__wrap">
          <h2 className="cta__title">
            Ready to Elevate Your <br />
            <span>Business Presence?</span>
          </h2>

          <p className="cta__sub">
            Join professionals who trust Xceed Office for their workspace <br />
            needs.
          </p>

          <div className="cta__actions">
            <button className="cta__btn cta__btn--primary" type="button">
              <span className="cta__btnIcon"><IconCalendar /></span>
                            <a href="https://calendly.com/xceedoffice-info/new-meeting?month=2026-03">Schedule a Tour</a> <span className="cta__arrow">→</span>
            </button>

            <button className="cta__btn cta__btn--ghost" type="button">
              <span className="cta__btnIcon"><IconCall /></span>
               <a href="tel:+1 (281) 270-6431">Call Now</a>
            </button>
          </div>

        </div>
      </section>


    </div>
  )
}

export default ExectiveOffices